import React from 'react';
import { Box, Typography } from '@mui/material';

const SummaryBox = ({ cartItems }) => {
  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.quantity * item.product.productCost,
    0,
  );

  return (
    <Box>
      <Typography variant="subtitle1">
        Total Items: <strong>{totalItems}</strong>
      </Typography>
      <Typography variant="subtitle1">
        Total Price: <strong>£{totalPrice.toFixed(2)}</strong>
      </Typography>
    </Box>
  );
};

export default SummaryBox;
